document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initGaleria();
  initVariantes();
});

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry, i) {
      if (entry.isIntersecting) {
        var el = entry.target;
        var delay = parseInt(el.dataset.mtDelay || '0', 10);
        setTimeout(function () { el.classList.add('mt-visible'); }, delay);
        obs.unobserve(el);
      }
    });
  }, { threshold: 0.12 });
  els.forEach(function (el) { obs.observe(el); });
}

function initGaleria() {
  var galeria = document.querySelector('[data-mt-galeria]');
  if (!galeria) return;
  var principal = galeria.querySelector('[data-mt-galeria-principal]');
  var minis = galeria.querySelectorAll('[data-mt-galeria-mini]');
  if (!principal || !minis.length) return;
  minis.forEach(function (mini) {
    mini.addEventListener('click', function () {
      var full = mini.getAttribute('data-mt-full');
      var alt = mini.getAttribute('data-mt-alt') || '';
      if (full) {
        principal.src = full;
        principal.alt = alt;
      }
      minis.forEach(function (m) { m.classList.remove('mt-activa'); });
      mini.classList.add('mt-activa');
    });
  });
}

function initVariantes() {
  var form = document.querySelector('#mt-producto-form');
  if (!form) return;
  var dataEl = document.querySelector('[data-mt-variantes-json]');
  if (!dataEl) return;
  var variantes;
  try {
    variantes = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  var pills = form.querySelectorAll('[data-mt-opcion-valor]');
  var idInput = form.querySelector('input[name="id"]');
  var precioEl = document.querySelector('[data-mt-precio]');
  var precioAntesEl = document.querySelector('[data-mt-precio-antes]');
  var botonComprar = form.querySelector('[data-mt-boton-comprar]');
  var estadoStock = document.querySelector('[data-mt-estado-stock]');
  var seleccion = {};

  pills.forEach(function (pill) {
    if (pill.classList.contains('mt-activa')) {
      seleccion[pill.dataset.mtOpcionNombre] = pill.dataset.mtOpcionValor;
    }
  });

  function moneyFmt(cents) {
    return (cents / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }

  function actualizar() {
    var match = variantes.find(function (v) {
      return v.opciones.every(function (o) { return seleccion[o.nombre] === o.valor; });
    });
    if (!match) return;

    idInput.value = match.id;
    if (precioEl) precioEl.textContent = moneyFmt(match.precio);
    if (precioAntesEl) {
      if (match.precioAntes && match.precioAntes > match.precio) {
        precioAntesEl.textContent = moneyFmt(match.precioAntes);
        precioAntesEl.style.display = '';
      } else {
        precioAntesEl.style.display = 'none';
      }
    }
    if (botonComprar) {
      botonComprar.disabled = !match.disponible;
      botonComprar.textContent = match.disponible ? botonComprar.dataset.mtTextoDisponible : botonComprar.dataset.mtTextoAgotado;
    }
    if (estadoStock) {
      estadoStock.textContent = match.disponible ? estadoStock.dataset.mtTextoDisponible : estadoStock.dataset.mtTextoAgotado;
      estadoStock.classList.toggle('mt-disponible', match.disponible);
      estadoStock.classList.toggle('mt-agotado', !match.disponible);
    }

    pills.forEach(function (pill) {
      var nombre = pill.dataset.mtOpcionNombre;
      var valor = pill.dataset.mtOpcionValor;
      var pruebaSeleccion = Object.assign({}, seleccion, { [nombre]: valor });
      var existeDisponible = variantes.some(function (v) {
        return v.opciones.every(function (o) { return pruebaSeleccion[o.nombre] === o.valor; }) && v.disponible;
      });
      pill.disabled = !existeDisponible && nombre !== undefined && !variantes.some(function (v) {
        return v.opciones.every(function (o) { return pruebaSeleccion[o.nombre] === o.valor; });
      });
    });
  }

  pills.forEach(function (pill) {
    pill.addEventListener('click', function () {
      var nombre = pill.dataset.mtOpcionNombre;
      var grupo = form.querySelectorAll('[data-mt-opcion-nombre="' + nombre + '"]');
      grupo.forEach(function (p) { p.classList.remove('mt-activa'); });
      pill.classList.add('mt-activa');
      seleccion[nombre] = pill.dataset.mtOpcionValor;
      actualizar();
    });
  });
}
